export const NavigationizerFeatureFlags = {
  isNew: 'featureFlag1',
  isSale: 'featureFlag2',
  hideFromBorderfree: 'featureFlag3',
  isMobileOnly: 'featureFlag5',
  isDesktopOnly: 'featureFlag6',
};
